<template>
  <div class="checkPoint" id="checkPoint">
    <div v-if="com === 'bind'">
      <bind :user="user" :liffAccessToken="liffAccessToken"></bind>
    </div>
    <div v-else-if="com === 'lucky'" class="else">
      <lucky :liffAccessToken="liffAccessToken"></lucky>
      <!-- <el-button type="info" @click="com = 'bind'">bind</el-button> -->
    </div>
  </div>
</template>

<script>
import liff from "@line/liff";
import axios from "axios";
import bind from "./bind";
import lucky from "./lucky";

export default {
  name: "checkPoint",
  components: { bind, lucky },
  data() {
    return {
      liffId: this.$route.query.id,
      liffAccessToken: "",
      com: "",
      user: {}
    };
  },
  mounted() {
    if (liff.getOS() === "web") {
      document.getElementById("checkPoint").innerHTML = "<p style='margin:1rem;'>請至智慧型手機使用相關功能！</p>";
    } else {
      this.liffInit();
    }
  },
  methods: {
    liffInit() {
      liff
        .init({
          liffId: this.liffId
        })
        .then(() => {
          this.liffAccessToken = liff.getAccessToken();
          if (!this.liffAccessToken) {
            alert("accessToken error");
          } else {
            this.getUser();
            this.recordEvent("liff_checkPoint");
          }
        })
        .catch(error => {
          alert(`LiffInit error: ${JSON.stringify(error)}`);
        });
    },
    getUser() {
      axios({
        method: "get",
        url: "/user/get",
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken
        }
      }).then(({ data: { user } }) => {
        // alert(`getUser : ${JSON.stringify(res)}`);
        if (!user || !user.clubGGId || !user.clubGGIdReviewed || user.clubGGIdReviewMsg) {
          this.user = user;
          this.com = "bind";
        } else {
          this.com = "lucky";
        }
      });
    },
    recordEvent(event) {
      axios({
        method: "post",
        url: "/event_record",
        data: {
          event: event,
        },
        headers: {
          "Content-Type": "application/json",
          "Access-Token": this.liffAccessToken,
        },
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.id-region {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.id-unit {
  width: 32px;
}
.id-unit/deep/.el-input__inner {
  padding: 0 10px;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -999;
}
.bg img {
  min-height: 100%;
  width: 100%;
}
.main {
  display: flex;
  justify-content: center;
  align-items: center;
}
.msg {
  font-size: 1.4rem;
  text-align: center;
  word-wrap: break-word;
  width: 90%;
  height: 50%;
  color: black;
  background-color: burlywood;
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 0.8rem;
}

.bg-dark {
  background-color: #343a40cc !important;
}
/deep/.modal-content {
  width: 90%;
  left: 5%;
  background-color: #000c;
  color: wheat;
  border-radius: 1rem;
}
.modal-div-edit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-div {
  // margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-div-d {
  margin: 1rem;
  word-wrap: break-word;
  text-align: center;
}
.modal-comment {
  border: 1px solid wheat;
  margin-top: 4px;
}
.delete-modal {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/checkPoint.vue